Mobi2Go.onReady(() => {
    const { UI } = Mobi2Go;
    if (Mobi2Go.headoffice.message) {
        UI.centeredAlert({
            title: Mobi2Go.headoffice.name,
            body: Mobi2Go.headoffice.message,
        });
    }
});
